/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXlc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M20.8 11.887c.243 0 .469.025.676.076.207.05.39.115.546.193v.911a4.295 4.295 0 0 0-.635-.193 2.478 2.478 0 0 0-.511-.056c-.474 0-.838.14-1.09.421s-.38.68-.38 1.195c0 .556.124.986.372 1.29.249.299.615.448 1.098.448.193 0 .388-.02.586-.062.202-.046.435-.115.697-.207v.897c-.18.083-.389.152-.628.207-.234.06-.494.09-.779.09-.805 0-1.415-.229-1.83-.684-.413-.46-.62-1.12-.62-1.98 0-.528.101-.982.303-1.359.203-.381.49-.674.863-.877.372-.207.817-.31 1.332-.31zm-8.958 1.831 1.008-1.735h1.186l-1.476 2.432L14.112 17h-1.235l-1.12-1.897L10.684 17H9.496l1.547-2.603-1.472-2.414h1.236zm3.895 2.323h2.208V17H14.66v-5.017h1.077z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXlc as FileXlc };
